module.exports = __webpack_public_path__ + "299f01e6c3d137c0f144d94dce12b2a2.png";